import { Button } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import {
    DialogSize,
    ResizableDialog,
} from '../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import {
    defaultSystemAnnouncementResource,
    SystemAnnouncementMutationResourceSchema,
    useSystemAnnouncementActions,
} from '../../../../resource/resources/persistables/system/announcement/systemAnnouncementResource';
import {
    defaultSystemAnnouncementUserDismissalResource,
    useSystemAnnouncementUserDismissalActions,
} from '../../../../resource/resources/persistables/system/announcement/systemAnnouncementUserDismissalResource';
import { useUserId } from '../../../authentication/useUserId';
import { SystemAnnouncementContent } from '../../../reusable-components/resource-contents/SystemAnnouncementContent';

export const SystemAnnouncementDialog = ({
    id,
    needsDismiss,
    onClose,
}: {
    id: string;
    needsDismiss: boolean;
    onClose: () => void;
}) => {
    const queryClient = useQueryClient();
    const userId = useUserId('');

    const systemAnnouncementActions = useSystemAnnouncementActions();
    const systemAnnouncementUserDismissalActions = useSystemAnnouncementUserDismissalActions();

    const resourceQuery = systemAnnouncementActions.useGetResource(id);
    const dismissAnnouncement = systemAnnouncementUserDismissalActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: SystemAnnouncementMutationResourceSchema,
        defaultValues: defaultSystemAnnouncementResource,
        submitHandler: async () => {
            await dismissAnnouncement.mutateAsync({
                resource: {
                    ...defaultSystemAnnouncementUserDismissalResource,
                    user: userId,
                },
                parentId: id,
            });
            void queryClient.invalidateQueries({ queryKey: ['ACTIVE_SYSTEM_ANNOUNCEMENTS', userId] });
            onClose();
        },
        reactiveValues: resourceQuery.data,
    });

    return (
        <ResizableDialog
            onClose={onClose}
            canClose={!needsDismiss}
            disableBackdropClick={true}
            title={'System Announcement'}
            dialogSize={DialogSize.MEDIUM}
            actions={
                needsDismiss ?
                    <Button onClick={onSubmit} size={'small'} variant={'filled'}>
                        Dismiss
                    </Button>
                :   <Button onClick={onClose} size={'small'} variant={'filled'}>
                        Close
                    </Button>
            }
        >
            <SystemAnnouncementContent id={id} form={form} formNames={formNames} readOnly={true} withoutTimes={true} />
        </ResizableDialog>
    );
};
